<template>
  <div>
    <div class="d-flex align-items-center justify-content-between gap-4 mb-3">
      <h2 class="h4 font-weight-semi-bold text-dark m-0">
        <slot name="title" />
      </h2>

      <a v-if="headLink.url" :href="headLink.url" class="d-inline-flex align-items-center gap-2 text-primary">
        {{ headLink.caption }}
        <i v-if="headLink.iconClass" :class="headLink.iconClass" />
      </a>
    </div>
    <div :class="slotWrapClasses">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    slotWrapClasses: { type: String, default: '' },
    headUrl: { type: Object, default: null }
  },
  computed: {
    headLink() {
      return {
        ...{
          url: '',
          caption: '',
          iconClass: 'fa-regular fa-arrow-right-long'
        },
        ...this.headUrl
      }
    }
  }
}
</script>
